import React from "react";

export function userInitial(name = "User") {
  return String(name || "U").trim().slice(0, 1).toUpperCase() || "U";
}

export function defaultAvatarDataUrl(name = "User") {
  const initial = userInitial(name);
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" viewBox="0 0 96 96"><rect width="96" height="96" rx="48" fill="#c8ff00"/><text x="48" y="58" text-anchor="middle" font-family="Arial, sans-serif" font-size="38" font-weight="900" fill="#050505">${initial}</text></svg>`;
  return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
}

/**
 * Resolve a Discord-aware avatar URL.
 * - If avatar_hash starts with "a_" the avatar is animated → force .gif extension.
 * - Otherwise return the URL as-is.
 * Works on raw Discord CDN URLs and on uploaded URLs.
 */
export function resolveAvatarUrl(user, src) {
  const url = src || user?.avatar_url || "";
  if (!url) return "";
  const hash = user?.avatar_hash || "";
  const isAnimated = typeof hash === "string" && hash.startsWith("a_");
  if (isAnimated && /cdn\.discordapp\.com\/avatars\//.test(url)) {
    return url.replace(/\.(png|jpg|jpeg|webp)(\?.*)?$/i, ".gif$2");
  }
  return url;
}

export function UserAvatar({ user, name, src, size = 36, className = "", testId = "user-avatar" }) {
  const displayName = name || user?.discord_username || user?.username || user?.email || "User";
  const resolvedSrc = resolveAvatarUrl(user, src) || defaultAvatarDataUrl(displayName);
  return (
    <img
      data-testid={testId}
      src={resolvedSrc}
      alt={displayName}
      // GIF avatars autoplay natively; no lazy loading on visible avatars
      decoding="async"
      className={`shrink-0 rounded-full border border-[#c8ff00]/20 object-cover ${className}`}
      style={{ width: size, height: size }}
    />
  );
}
